import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Top scroll-progress bar + floating back-to-top button
export default function TopProgress() {
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setProgress(max > 0 ? (h.scrollTop / max) * 100 : 0);
      setShow(h.scrollTop > 700);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="fixed top-0 left-0 right-0 h-[2px] z-[60] bg-transparent">
        <div className="h-full bg-brand-accent transition-[width] duration-150 ease-out" style={{ width: `${progress}%` }} />
      </div>
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Başa dön"
        data-testid="back-to-top-btn"
        className={`fixed bottom-[92px] right-6 z-50 w-11 h-11 rounded-full bg-white/90 backdrop-blur border border-brand-line text-brand-ink shadow-[0_12px_30px_-16px_rgba(12,19,34,0.6)] flex items-center justify-center transition-[opacity,transform,background-color,color] duration-300 hover:bg-brand-accent hover:text-white hover:border-brand-accent ${
          show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <ArrowUp className="w-4 h-4" />
      </button>
    </>
  );
}
